import { Stack, Typography } from "@mui/material";
import { CustomSwitch } from "./utils";
import { useBoundStore } from "useStore";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

export default function AutomationSwitch() {
  const showAutomation = useBoundStore((state) => state.campaignAutomationShow);
  const toggleShowAutomation = useBoundStore(
    (state) => state.toggleCampaignAutomationShow,
  );

  const handleChange = () => {
    toggleShowAutomation();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        padding: "12px",
        width: "182px",
        borderRadius: "4px",
        border: "1px solid rgba(0, 0, 0, 0.23)",
      }}
      spacing={1}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <SettingsOutlinedIcon
          sx={{
            width: "24px",
            height: "24px",
            fill: "#5E35B1",
          }}
        />
        <Typography
          component="label"
          htmlFor="automation-switch"
          sx={{
            color: "#00000099",
            fontSize: "16px",
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}
        >
          Automation
        </Typography>
      </Stack>

      <CustomSwitch
        size="small"
        id="automation-switch"
        checked={showAutomation}
        onChange={handleChange}
        inputProps={{ "aria-label": "controlled" }}
        color="secondary"
      />
    </Stack>
  );
}
